// src/utils/sessionManager.js

export const handleUnauthorized = async () => {
    const rememberedEmail = localStorage.getItem("rememberedEmail");
    const rememberedPassword = localStorage.getItem("rememberedPassword");

    localStorage.clear();

    if (rememberedEmail) {
        localStorage.setItem("rememberedEmail", rememberedEmail);
    }
    if (rememberedPassword) {
        localStorage.setItem("rememberedPassword", rememberedPassword);
    }

    try {
        const { default: store } = await import("../redux/store");
        const { logoutUser } = await import("../redux/ReduxSlices/authSlice");

        store.dispatch(logoutUser());
    } catch (err) {
        console.warn("Failed to dispatch logoutUser:", err);
    }

    window.location.href = "/signin";
};
